"use client";

import DeliverArrest from "./DeliverArrest";
import DeliverFasterSales from "./DeliverFasterSales";
import DeliverReduceTime from "./DeliverReduceTime";


export interface QBosonDeliverBlockProps {
  title: string;
  subtitle: string;
  description: string;
}

interface QBosonDeliverProps {
  data: {
    titleBosonDeliver: string;
    firstBlock: QBosonDeliverBlockProps;
    secondBlock: QBosonDeliverBlockProps;
    thirdBlock: QBosonDeliverBlockProps;
  };
}

export default function QBosonDeliver({ data }: QBosonDeliverProps) {
  return (
    <div className='bg-white flex items-center py-[80px] lg:py-[120px] px-[24px]'>
      <div className='mx-auto w-full lg:w-10/12 xl:w-9/12 4xl:w-10/12'>
        <h2
          dangerouslySetInnerHTML={{ __html: data.titleBosonDeliver }}
          className='text-[#032D60] text-center !leading-[1.2] text-5xl 2xl:text-6xl font-bold mx-auto mb-[30px] md:mb-[60px]'
        />
        <div className='flex flex-col md:flex-row items-center justify-center gap-[32px] md:gap-[24px] 2xl:gap-[48px]'>
          <div className="min-w-[220px]">
           <DeliverArrest title={data.firstBlock.title}  subtitle={data.firstBlock.subtitle}  description={data.firstBlock.description} />
          </div>
          <div className="min-w-[220px]">
           <DeliverFasterSales title={data.secondBlock.title}  subtitle={data.secondBlock.subtitle}  description={data.secondBlock.description} />
          </div>
          <div className="min-w-[220px]">
           <DeliverReduceTime />
          </div>
        </div>
      </div>
    </div>
  );
}
